import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, type PublicResult } from "@app/api/client.ts";
import { track } from "@app/analytics.ts";
import { BAND_UI } from "@app/format.ts";
import { MAX_SCORE_PER_ROUND } from "@shared/share";

export function ResultShare() {
  const { shareId } = useParams();
  const [result, setResult] = useState<PublicResult | null>(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (!shareId) return;
    track({ name: "result_page_view", referrerShareId: shareId });
    void api
      .result(shareId)
      .then(setResult)
      .catch(() => setMissing(true));
  }, [shareId]);

  return (
    <section className="screen screen--scroll" aria-labelledby="shareTitle">
      <div className="results">
        {missing ? (
          <p className="status" role="alert">
            Este resultado ya no está disponible.
          </p>
        ) : !result ? (
          <p className="status">Cargando resultado…</p>
        ) : (
          <>
            <div className="scorebox">
              <h1 className="scorebox__k" id="shareTitle">
                Ronda #{result.roundNumber} · Resultado compartido
              </h1>
              <div className="big">
                {result.total}
                <small>/{MAX_SCORE_PER_ROUND}</small>
              </div>
              <div className="chips">
                {result.bands.map((band, index) => (
                  <div
                    key={index}
                    className={`chip chip--${BAND_UI[band].cls}`}
                    aria-label={`Pista ${index + 1}: banda ${band}`}
                  >
                    <i aria-hidden="true">{BAND_UI[band].icon}</i>
                  </div>
                ))}
              </div>
            </div>
            {result.viewer ? (
              <div className="scorebox">
                <div className="scorebox__k">Tu resultado de esa ronda</div>
                <b>
                  {result.viewer.total}/{MAX_SCORE_PER_ROUND}
                </b>
                <p className="pct">
                  {result.viewer.total > result.total
                    ? "¡Ganaste este duelo!"
                    : result.viewer.total === result.total
                      ? "Empate"
                      : "Esta vez te superó"}
                </p>
              </div>
            ) : null}
            <Link className="cta" to="/">
              Juega la ronda de hoy
            </Link>
          </>
        )}
      </div>
    </section>
  );
}
